// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__2uoec","title":"AfterFrontImage_title__3wVMG"};